"use client";
import CustomTextField from "@/components/common/CustomeTextField";
import CustomeTextArea from "@/components/common/CustomTextArea";
import React from "react";

const GetQuoteForm = ({
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
}: {
    values: {
        Name: string;
        EmailID: string;
        PhoneNo: string;
        Message: string;
    };
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    handleBlur: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    errors: {
        Name?: string;
        EmailID?: string;
        PhoneNo?: string;
        Message?: string;
    };
    touched: {
        Name?: boolean;
        EmailID?: boolean;
        PhoneNo?: boolean;
        Message?: boolean;
    };
}) => {
    return (
        <div className="space-y-4 text-black"> 
            <CustomTextField
                placeholder="Name"
                name="Name"
                value={values?.Name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors?.Name && touched?.Name)}
                helperText={touched?.Name ? errors?.Name : ""}
            />
            <CustomTextField
                placeholder="Email"
                name="EmailID"
                value={values?.EmailID}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors?.EmailID && touched?.EmailID)}
                helperText={touched?.EmailID ? errors?.EmailID : ""}
            />
            <CustomTextField
                placeholder="Phone Number"
                name="PhoneNo"
                value={values?.PhoneNo}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors?.PhoneNo && touched?.PhoneNo)}
                helperText={touched?.PhoneNo ? errors?.PhoneNo : ""}
            />
            <CustomeTextArea
                placeholder="Message"
                name="Message"
                value={values?.Message}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors?.Message && touched?.Message)}
                helperText={touched?.Message ? errors?.Message : ""}
            />
        </div>
    );
};

export default GetQuoteForm;